'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import './accordion.css';
/**
 * Accordion — a simple details/summary-based accordion component.
 *
 * @param {arrayOf} [props.items] - Array of items each with `title`, `content`, and optional `open` state.
 * @param {string} [props.title] - Title or header for an accordion item.
 * @param {oneOfType} [props.content] - Content for an accordion item, either string or React node.
 * @param {boolean} [props.open] - Initial open state of an item (when true the item is expanded).
 * @param {function} [props.onToggle] - Optional callback called when an item is toggled (index, isOpen).
 */
Accordion.propTypes = {
    /** Array of accordion items to render. */
    items: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
        open: PropTypes.bool,
    })).isRequired,
    /** Called when an item is toggled with (index, isOpen). */
    onToggle: PropTypes.func,
};
export function Accordion({ items, onToggle }) {
    return (_jsx("div", { className: "accordion", children: items?.map((item, index) => (item ? (_jsxs("details", { className: "accordion-item", open: item.open ?? undefined, onToggle: onToggle ? (e) => onToggle(index, e.target.open) : undefined, children: [_jsx("summary", { className: "accordion-title", children: _jsx("h3", { id: `accordion-header-${index}`, children: item.title }) }), _jsx("div", { className: "accordion-content", role: "region", "aria-labelledby": `accordion-header-${index}`, children: typeof item.content === 'string' ? (_jsx("p", { children: item.content })) : (item.content) })] }, index)) : null)) }));
}
